export const pageSizeOption = Object.freeze({
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  DEFAULT_PAGE_SIZE: 20,
});
